/**
 * AsyncComponent
 * Code Splitting Component / Server Side Rendering
 */
import { lazy } from 'react';

// Dashboard
export const AsyncDashboardComponent = lazy(() => import('../../routes/dashboard/main'));
export const AsyncDashboardAllComponent = lazy(() => import('../../routes/dashboard/all'));

//Field
export const AsyncFieldDetail = lazy(() => import('../../routes/field/detail'));
export const AsyncFieldDetailWorkLogComponent = lazy(() => import('../../routes/field/worklog'));
export const AsyncFieldMinutesOfMeetings = lazy(() => import('../../routes/field/detail/MinutesOfMeetingsSection/MinutesOfMeetingList'));
export const AsyncFieldMinutesOfMeetingsDetail = lazy(() => import('../../routes/field/detail/MinutesOfMeetingsSection/MinutesOfMeetingDetail'));
export const AsyncFieldMinutesOfMeetingsCreate = lazy(() => import('../../routes/field/detail/MinutesOfMeetingsSection/MinutesOfMeetingCreate'));
export const AsyncFieldMinutesOfMeetingsUpdate = lazy(() => import('../../routes/field/detail/MinutesOfMeetingsSection/MinutesOfMeetingUpdate'));
// export const AsyncFieldContractDetail = lazy(() => import('../../routes/field/detail/ContractSection/ContractDetail'));
// export const AsyncFieldContractCreate = lazy(() => import('../../routes/field/detail/ContractSection/ContractCreate'));

//Transaction
export const AsyncAccountantTransactionsListComponent = lazy(() => import('../../routes/transaction/transactions/list'));
export const AsyncOrderListComponent = lazy(() => import('../../routes/transaction/order/list'));
export const AsyncOrderDetailComponent = lazy(() => import('../../routes/transaction/order/detail'));

//Calendar
export const AsyncCalendarComponent = lazy(() => import('../../routes/calendar'));

// Order
export const AsyncOrderMainComponent = lazy(() => import('../../routes/order/pages/main'));
export const AsyncOrderMainDetailComponent = lazy(() => import('../../routes/order/pages/detail'));
export const AsyncOrderShoppingCartComponent = lazy(() => import('../../routes/order/pages/shopping-cart'));
export const AsyncOrderConfirmComponent = lazy(() => import('../../routes/order/pages/confirm'));
export const AsyncOrderCompleteComponent = lazy(() => import('../../routes/order/pages/complete'));

// Setting
export const AsyncUserListComponent = lazy(() => import('../../routes/setting/user/list'));
export const AsyncUserDetailComponent = lazy(() => import('../../routes/setting/user/detail'));
export const AsyncUserCreateComponent = lazy(() => import('../../routes/setting/user/create'));
export const AsyncUserModifyComponent = lazy(() => import('../../routes/setting/user/modify'));
export const AsyncFavoriteComponent = lazy(() => import('../../routes/setting/favorite'));
export const AsyncMeComponent = lazy(() => import('../../routes/setting/me'));

// Internal Notice
export const AsyncInternalNoticeListComponent = lazy(() => import('../../routes/internal-notice/list'));
export const AsyncInternalNoticeDetailComponent = lazy(() => import('../../routes/internal-notice/detail'));
export const AsyncInternalNoticeCreateComponent = lazy(() => import('../../routes/internal-notice/create'));
export const AsyncInternalNoticeModifyComponent = lazy(() => import('../../routes/internal-notice/modify'));

// Private Note
export const AsyncPrivateNoteComponent = lazy(() => import('../../routes/private-note'));

// Staff
export const AsyncStaffListComponent = lazy(() => import('../../routes/staff/list'));
export const AsyncStaffCreateComponent = lazy(() => import('../../routes/staff/create'));
export const AsyncStaffDetailComponent = lazy(() => import('../../routes/staff/detail'));
export const AsyncStaffModifyComponent = lazy(() => import('../../routes/staff/modify'));
